<template>
  <div class="popup_in">
    <div class="popup ivf-popup" v-click-outside="clickOutside">
      <div class="popup_close popup_close-25 close-animate">
        <a href="javascript:void(0);" @click="$emit('close')"><CloseBlue /></a>
      </div>
      <div class="popup-content">
        <div class="title--32 tx--blue2">טפסי הסכמה</div>
        <div class="mb--22">
          רופא/ה יקר/ה, <br />
          יש לבחור את טופס ההסכמה המבוקש מהרשימה המוצגת. מיד לאחר הלחיצה על
          הכפתור, יוצג הטופס בפניך לשם השלמת הפרטים ע"י המטופל/ת. לאחר השלמתם,
          עליך לחתום על הטופס במקום המיועד וללחוץ על הכפתור "שלח טופס" לשם השלמת
          הפעולה.
        </div>
        <div class="content has--scroll">
          <a
            v-for="template in templates"
            :key="template.key"
            class="table-file flex"
            href="javascript:void(0)"
            @click="submitForm(template.key)"
          >
            <img class="svg" src="/assets/img/svg/ic-file.svg" />
            <span class="is--fit tx_file text--right">{{ template.name }}</span>
            <span
              v-show="!loadingTemplates[template.key]"
              class="files-overlay-show tx-blue pointer"
              >שלח</span
            >
            <vue-loaders-ball-clip-rotate
              v-show="loadingTemplates[template.key]"
              color="#4A90E2"
              scale="0.5"
              class="ivf-loader-inline"
            ></vue-loaders-ball-clip-rotate>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CloseBlue from "../../assets/img/svg/close-blue.svg";
import ClickOutside from "vue-click-outside";
import { ivfTemplates } from "../../utilities/ivf";
import { sendCelloSignGeneric } from "../../api/api-quatro.js";
import { mapState } from "vuex";

const IVF_BPMN_BASE = "https://app.cellosign.com/api/v3/ivf_forms/bpmn";
const IVF_PROJECT = "ivf_forms";
const IVF_TOKEN = "340564a53b3d5c5044ed65433cc5b73c16eacd59";

const buildIvfBpmnUrl = template => `${IVF_BPMN_BASE}/${template}/start/`;

export default {
  props: {
    patientData: { default: () => {} }
  },
  data() {
    return {
      templates: ivfTemplates,
      loadingTemplates: {}
    };
  },
  computed: {
    ...mapState(["activeDoctor"])
  },
  methods: {
    /**
     * Submit the form and send the consent to the cellosign.
     */
    async submitForm(templateKey) {
      if (this.loadingTemplates[templateKey] || !this.activeDoctor) return;

      this.$set(this.loadingTemplates, templateKey, true);

      const data = {
        id: templateKey,
        phone: this.patientData.phone,
        heb_name: this.activeDoctor.name,
        license: this.activeDoctor.license,
        mdbid: this.activeDoctor.id || "3136",
        wait_for_first_session: true,
        passport: this.patientData.passport || "",
        firstName: this.patientData.firstName || "",
        lastName: this.patientData.lastName || ""
      };

      const req = {
        url: buildIvfBpmnUrl(templateKey),
        template: templateKey,
        project: IVF_PROJECT,
        token: IVF_TOKEN,
        data
      };

      try {
        const response = await sendCelloSignGeneric(req);
        const url = response?.data?.data?.session?.client_url;
        window.open(url, "_blank");
      } catch (error) {
        console.error("Error sending consent cellosign", error);
      } finally {
        this.$set(this.loadingTemplates, templateKey, false);
      }
    },
    /**
     * Click outside of the popup.
     */
    clickOutside() {
      this.$emit("close");
    }
  },
  components: {
    CloseBlue
  },
  directives: {
    ClickOutside
  }
};
</script>

<style>
.ivf-popup {
  max-width: 615px;
}

.ivf-popup .content {
  max-height: 40vh;
  overflow-y: auto;
}

.ivf-loader-inline {
  display: inline-block;
  margin-right: 10px;
}
</style>
